<template>
	<div>
		<slot name="title">
			<div class="title-area">{{ item.title }}</div>
			<div v-if="item.description">{{ item.description }}</div>
		</slot>
		<slot name="value">
			<DefaultPropertyInput :value="item.value" readonly class="first-letter-uppercase" />
		</slot>
	</div>
</template>

<script>
import DefaultPropertyInput from '../BlockEditorParams/inputsComponents/DefaultPropertyInput.vue';
export default {
	name: 'FormItem',
	props: { item: { type: Object } },
	components: { DefaultPropertyInput },
};
</script>
<style lang="scss" scoped>
.title-area {
	font-size: 14px;
	font-weight: 500;
}
</style>
